import styled from "@emotion/styled";
import { color } from "@smartsheet/design-tokens-react";
import { getInputFieldHeightValue } from "../../../../util/inputFieldBaseProps";
import { withFocusToggleClassName } from "../../../../util/withFocusClassName";
import { menuTheme } from "../../../menu/styled/menuTheme";
import { formInputTheme } from "../../../textinput/styled/formInputTheme";
import { selectV2Theme } from "../selectV2Theme";
export const ComboBoxInput = withFocusToggleClassName(styled("input")`
    display: block;
    width: 100%;
    // Override some UA styles.
    font-family: inherit;
    color: ${color("color--text--neutral--strong")};
    font-size: ${_ref => {
  let {
    themeMode
  } = _ref;
  return menuTheme.fontSize(themeMode);
}};
    line-height: 18px;
    padding: ${_ref2 => {
  let {
    isContentBeforeVisible,
    themeMode
  } = _ref2;
  return isContentBeforeVisible ? "0 0 0 0" : `0 0 0 ${selectV2Theme.input.padding.left(themeMode)}`;
}};
    height: ${_ref3 => {
  let {
    themeMode,
    inputFieldHeight
  } = _ref3;
  return `var(--sds--form--height--${inputFieldHeight === 32 ? "default" : "large"}, ${formInputTheme.height[getInputFieldHeightValue(themeMode, inputFieldHeight)](themeMode)}px)`;
}};
    box-sizing: border-box;
    border-radius: 4px;
    position: relative;

    // To show over the selected value facade.
    z-index: 1;

    border: 0px;
    background-color: transparent;
    cursor: inherit;

    &:focus,
    &:focus-visible {
        outline: none;
    }
`);
//# sourceMappingURL=ComboBoxInput.js.map